import styled, { css } from 'styled-components/macro';
import redisLogo from 'assets/icons/RedisLogo.svg';
import { FORM_MARGIN_RIGHT, FORM_WIDTH } from 'screens/Login/Login.style';

export const BackgroundImageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  scrollbar-gutter: stable;
  justify-content: space-between;
  overflow: auto;

  ${({ theme }) =>
    css`
      background-color: ${theme.appComponents.login.login.background.backgroundColor};
      background-image: ${theme.appComponents.login.login.background.backgroundImage};
      background-repeat: no-repeat;
      background-size: min(57vh, 110vw - ${FORM_WIDTH} - ${FORM_MARGIN_RIGHT});
      background-position: calc(50% - ${FORM_WIDTH} / 2 - ${FORM_MARGIN_RIGHT} / 2) 100%;
    `}
`;

export const RedisLogo = styled.div`
  width: 10.1rem;
  height: 4rem;
  margin: 3rem 0 0 3rem;
  background: url(${redisLogo}) no-repeat;
`;
